import React, { useEffect, useState, Fragment } from "react";
import GeneralBuildingSearchBar from "../../../../shared/components/building_filters/GeneralBuildingSearchBar";
import RecentHistory from "./RecentHistory";
import { TextField, Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import RefreshIcon from "mdi-react/FileChartIcon";
import { loadCompDraft, deleteCompDraft, formatTimeAgo } from './compDraftStorage';

import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from "moment";

import { makeStyles } from "@material-ui/core/styles";
import { _axiosCall } from "../../../../shared/helpers/apicalls";
import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  _replaceAbbreviations,
  _formatBed,
  _isEqual,
  _tranformTagsQuery,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  _activityFL,
  _getFeaturesArr,
  _chunkArray,
  _isCoop,
  _validUnitSources,
  propertyExportFL,
  propertyFL,
  _formatNum,
  _getBuildingPhotos,
  _getServiceLevel,
  _checkBuildingAltAdr
} from "../../../../shared/helpers/utils";
import MediaUpload from "./mediaUpload";
import './CompPropertySelector.scss';

const apiURL = process.env.API_ROOT;

const searchBarBuildingStyles = makeStyles((theme) => ({
  appBar: {
	backgroundColor:'#F5F7FA !important',
	transform:'none !important',
	color:'#FFF !important',
	boxShadow:"none",
	padding: 'none !important',
	"& .MuiToolbar-gutters": {
	  paddingRight: "0px !important",
	  paddingLeft: "0px !important",
	},
  },
  grow: {
	flexGrow: 1,
  },
  menuButton: {
	marginRight: theme.spacing(2),
  },
  title: {
	display: 'none',
	[theme.breakpoints.up('sm')]: {
	  display: 'block',
	},
  },
  search: {
	position: "relative",
	borderRadius: theme.shape.borderRadius,
	backgroundColor: " #FFF !important",
	border:"2px solid #333",
	marginRight: "0px !important",
	marginLeft: "0px !important",
	width: "100%",
	padding:"2px 0",
	[theme.breakpoints.up("sm")]: {
	  marginLeft: 0,
	  width: "100%",
	  maxWidth: "none",
	},
	"& .c_search-result-container": {
	  boxShadow:"none",
	  top:"50px"
	},
	"& .c_input-tag": {
	  background: "#A3ADC2",
	  color: "#FFF",
	  "& .mdi-icon": {
		fill: "#FFF",
	  },
	},
	"& .poly_map_launcher": {
	  background: "#5C1F7A !important",
	},
	"&.MuiToolbar-gutters": {
	  paddingRight: 0,
	},
	"& .mdi-icon": {
	  fill: "#A3ADC2",
	},
	"& .c_clear-search" :{
	  color:"#780F9E"
	},
	"& .c_search-nav": {
	  color: "#A3ADC2",
	  "& .c_nav-input.MuiInputBase-input": {
		color: "#A3ADC2",
	  },
	},
  },
  searchIcon: {
	width: theme.spacing(7),
	height: "100%",
	position: "absolute",
	pointerEvents: "none",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
  },
  inputInput: {
	borderRadius: theme.shape.borderRadius,
	backgroundColor: " #FFF !important",
	width:"160px !important",
	padding:"16px !important"
  },
  inputInputLong: {
	  borderRadius: theme.shape.borderRadius,
	  backgroundColor: " #FFF !important",
	  padding:"16px !important",
	  width:"200px !important",
	},
  inputRoot: {
	color: 'inherit',
	width: '100%',
	border: 0,
	'&.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
	  padding:0
	},
	
  },
  outlinedTextField: {
	"&.MuiOutlinedInput-root": {
	  "& fieldset": {
		border: "2px solid #333",
	  },
	  "&:hover fieldset": {
		border: "2px solid #000",
	  },
	  "&.Mui-focused fieldset": {
		border: "2px solid #333",
	  },
	  
	},
	'&.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
	  padding:1,
	  background:"#FFF"
	}
  },
  sectionDesktop: {
	display: 'none',
	[theme.breakpoints.up('md')]: {
	  display: 'flex',
	},
  },
  sectionMobile: {
	display: 'flex',
	[theme.breakpoints.up('md')]: {
	  display: 'none',
	},
  },
  searchButton: {
	color: "#FFF",
	borderColor: "#FFF",
	backgroundColor: "#5C1F7A",
	margin: "0px 5px",
	padding:"5px 12px",
	"&:hover": {
	  borderColor: "#FFF",
	  backgroundColor: "#B070CC",
	},
	height: 50,
	boxShadow:
	  "rgba(0, 0, 0, 0.1) 0px 0px 1px -3px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
	"&.Mui-disabled": {
	  boxShadow: "none",
	  color: "#A3ADC2",
	  backgroundColor:"#DBE0E8",
	},
  },
  resetButton: {
	color: "#5C1F7A",
	borderColor: "#5C1F7A",
	backgroundColor: "#FFF",
	margin: "0px 5px",
	padding:"5px 20px",
	"&:hover": {
	  borderColor: "#FFF",
	  backgroundColor: "#B070CC",
	},
	height: 50,
	boxShadow:
	  "rgba(0, 0, 0, 0.1) 0px 0px 1px -3px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px, rgba(0, 0, 0, 0.1) 0px 1px 4px 0px",
	"&.Mui-disabled": {
	  boxShadow: "none",
	  color: "#9600BF",
	},
  },
}));
function formatCurrencyLive(value, prefix="$") {
  if (!value) return "";
  // Ensure the value is a string
  value = value.toString();
  
  // Split the value on the decimal point.
  const parts = value.split(".");
  // Format the integer part using toLocaleString.
  const intPart = parts[0] ? parseInt(parts[0], 10) : 0;
  const formattedInt = isNaN(intPart) ? "" : intPart.toLocaleString("en-US");
  
  let result = prefix + formattedInt;
  
  // If the user has typed a decimal point, append it and any following digits.
  if (value.includes(".")) {
	result += ".";
	if (parts[1]) {
	  result += parts[1];
	}
  }
  return result;
}

export default function PropertySelector(props) {
  const { updateBuildingReport, searchTags, clearTags, compSettings, setCompSettings, reportItem, onRestoreDraft } = props;
  const classes = searchBarBuildingStyles();

  const [savedDraft, setSavedDraft] = useState(null);

  useEffect(() => {
    const draft = loadCompDraft();
    if (draft && draft.compSettings && draft.compSettings.selectedBuilding) {
      setSavedDraft(draft);
    } else if (draft) {
      // Invalid draft (missing building data), clean it up
      deleteCompDraft();
    }
  }, []);

  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [units, setUnits] = useState(false);
  const [building, setBuilding] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [userAddedUnit, setUserAddedUnit] = useState(null);
  const [priceFocused, setPriceFocused] = useState(false);

  const [propertyDetails, setPropertyDetails] = useState({
	bedrooms: "",
	baths: "",
	sq_ft: "",
	customPrice: "",
	key: "",
	floor: "",
	property: null
  });
  
  const handleBuildingSelect = (building) => {
	console.log(building);
	setSelectedBuilding(building);
	if (building && building.key) {
	  fetchUnits(building.key);
	} else {
	  // if(!isHouse){
	  //  setUnits([]);
	  // }
	}
  };
  
  const handleUnitSelect = (unit) => {
	console.log(unit);
	if (!unit) {
	  reset();
	}
	
	let theUnit = units && units.filter(item => 
	  (unit && item && item.address_2_normalized && item.address_2_normalized.toLowerCase() === unit.toLowerCase())
	).length > 0 ? units.filter(item => 
	  (unit && item && item.address_2_normalized && item.address_2_normalized.toLowerCase() === unit.toLowerCase())
	)[0] : false;
	setSelectedUnit(unit);
	setDetailsFromUnit(theUnit, setPropertyDetails);
	
	setUserAddedUnit(null);
  };
  
  const handleDetailChange = (key, value) => {
	setPropertyDetails((prevDetails) => ({
	  ...prevDetails,
	  [key]: value,
	}));
  };
  
  const setDetailsFromUnit = (unit, setPropertyDetails) => {
	console.log(unit);
	if (unit) {
	  const { bedrooms, baths, sq_ft, key, floor } = unit;
  
	  setPropertyDetails((prevDetails) => ({
		...prevDetails,
		bedrooms: bedrooms > -1 ? bedrooms : "",
		baths: baths > -1 ? baths : "",
		sq_ft: sq_ft > 10 ? sq_ft : "",
		customPrice: "", // Reset custom price when selecting a unit
		key: key || "",
		floor: floor || "",
		property: unit || Object.assign({}, selectedBuilding, {address_2_normalized:userAddedUnit})
	  }));
	} else {
	  setPropertyDetails({
		bedrooms: "",
		baths: "",
		sq_ft: "",
		customPrice: "",
		key: "",
		floor: "",
		property: Object.assign({}, selectedBuilding, {address_2_normalized:userAddedUnit})
	  });
	}
  };
  
  const reset = () => {
	clearTags();
	setSelectedBuilding(null);
	setUnits(false);
	setSelectedUnit("");
	setUserAddedUnit("");
  };
  
  useEffect(() => {
	const building = searchTags.filter(item => item.type === "building");	  
	if(building.length > 0){
	  setSelectedBuilding(building[0].data);
	} else {
	  setSelectedBuilding(null);
	}
  }, [searchTags]);
  
  useEffect(() => {
	if(selectedBuilding){
	  fetchUnits();
	}
  }, [selectedBuilding]);
  
  useEffect(() => {
	setCompSettings({ selectedBuilding, selectedUnit, propertyDetails });
  }, [propertyDetails]);
  const fetchBuilding = async () => {
	  const addressQ = selectedBuilding.alternate_addresses.join('" OR "');
	  let q = `alternate_addresses:("${addressQ}") AND (zip:${selectedBuilding.zip} OR borough:"${selectedBuilding.borough.toLowerCase()}")`;
	 
	  const fq = [
		`deleted:false`,
	  ];
	  let axiosData = {
		url: apiURL + "/query/we3-buildings?cache=1440",
		method: "post",
		query: {
		  q: q,
		  wt: "json",
		  fl: "key,display_full_street_address,name,geocode,borough,neighborhood,markets_major,zip,floors,inventory_total,year_built,year_converted,building_service_level,building_access,amenities_health,ownership_type,sq_ft,total_units,building_style",
		  fq: fq,
		  rows: 999,
		},
	  };
	  let tableData = await _axiosCall(axiosData);
	
	  if(tableData){
		if(tableData.docs && tableData.docs[0]){
			setBuilding(tableData.docs[0]);
			
			return tableData.docs[0];
		}else{
			return false;
		}
		
	  }
	  return false;
	};
  const fetchUnits = async () => {
	const addressQ = selectedBuilding.alternate_addresses.join('" OR "');
	let q = `alternate_addresses:("${addressQ}") AND (zip:${selectedBuilding.zip} OR borough:"${selectedBuilding.borough.toLowerCase()}")`;
	let statsQ = "";
	
	let isCoop = _isCoop(selectedBuilding);
	let isHouse = _isHouse(selectedBuilding);
	
	if (!isHouse) {
	  if (["active"].indexOf(selectedBuilding.offering_verified_status) >= 0) {
		statsQ = `((offering_verified_status:active AND source_organizations:(CDEC NYAG ADEC) AND baths:[1 TO *]) OR verification_source:(user-verified-valid CDEC ADEC))`;
		q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}))`;
	  } else if (
		selectedBuilding.cdec_date &&
		parseInt(moment(selectedBuilding.cdec_date).format("YYYY")) > 1970 &&
		!isCoop
	  ) {
		let unitSource = "source_organizations:(CDEC ADEC)";
		if (
		  selectedBuilding.cdec_units_properties <
		  selectedBuilding.inventory_total * 0.8
		) {
		  unitSource = `(source_organizations:(CDEC ADEC) OR verification_source:(${_validUnitSources}))`;
		}
		statsQ = `(${unitSource} AND property_type:("" *condo* "resident manager unit" *coop* *affordable*) AND -property_type:*commercial* AND -property_type:*multi*)`;
		q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}) OR (current_status:(active "in contract")))`;
	  } else if (
		["coming soon"].indexOf(selectedBuilding.offering_verified_status) >= 0
	  ) {
		statsQ = `(source_organizations:NYAG AND offering_baths:[1 TO *] AND offering_price:* AND -offering_file_number:"")`;
		q += ` AND (${statsQ} OR verification_source:(${_validUnitSources}) OR (current_status:(active "in contract")))`;
	  } else if (!isCoop) {
		q += ` AND (source_organizations:(CDEC ADEC) OR verification_source:(${_validUnitSources}) OR (current_status:(active "in contract")))`;
	  }
	}
	const fq = [
	  `deleted:false`,
	  `${isHouse ? "" : "-address_2_normalized:\"\""}`,
	  `${isHouse ? "" : "(property_type:(*residential*condo* *bulk*condo* condo *co-op* \"condo unit\" \"resident manager unit\" *coop* *affordable* \"\" *dwelling* *timeshare* *residential* *apartment*))"}`
	];
	let axiosData = {
	  url: apiURL + "/query/we3-properties?cache=60",
	  method: "post",
	  query: {
		q: q,
		sort: "address_2_normalized asc",
		wt: "json",
		"fl": [
		  "full_street_address",
		  "display_full_street_address",
		  "zip",
		  "address_2",
		  "address_2_normalized",
		  "floor",
		  "bedrooms",
		  "baths",
		  "half_baths",
		  "sq_ft",
		  "exterior_sq_ft",
		  "offering_price",
		  "building",
		  "building_name",
		  "neighborhood",
		  "borough",
		  "monthly_fees",
		  "monthly_taxes",
		  "key",
		  "total_units",
		  "residential_units",
		  "last_sold_price",
		  "last_sold_date",
		  "price",
		  "last_listed_sale_price_all",
		  "last_listed_sale_date_all",
		  "last_listed_sale_modified_date_all",
		  "last_listed_sale_ppsf_all",
		  "last_listed_rent_price_all",
		  "last_listed_rent_date_all",
		  "last_contract_date",
		  "last_contract_price",
		  "last_contract_date_formatted",
		  "last_listed_sale_key_all",
		  "last_listed_rent_key_all",
		  "last_listed_sale_status_all",
		  "last_listed_rent_status_all",
		  "id",
		  "div(last_sold_price, sq_ft)",
		  "div(last_listed_sale_price_all, sq_ft)",
		  "div(last_contract_price, sq_ft)",
		  "div(sub(offering_price, last_listed_sale_price_all), offering_price)",
		  "div(sub(offering_price, last_sold_price), offering_price)",
		  "owner",
		  "ownership_type",
		  "borough_code",
		  "block",
		  "lot",
		  "year*",
		  "building_class",
		  "property_features",
		  "building_features",
		  "floor",
		  "last_listed_sale_price_all",
		  "last_listed_sale_ppsf_all",
		  "last_listed_sale_date_all",
		  "last_sold_price",
		  "last_sold_date",
		  "offering_price",
		  "offering_submitted_date",
		  "offering_reviewed_date",
		  "offering_accepted_date",
		  "offering_effective_date",
		  "property_status"
		],
		fq: fq,
		rows: 999,
	  },
	};
	let tableData = await _axiosCall(axiosData);
  
	if(tableData){
	  if(isHouse){
		  if(tableData.docs && tableData.docs[0]){
			  let building = await fetchBuilding();
			  let unit = tableData.docs[0];
			  if(unit.sq_ft < 100 && building.sq_ft > 100){
				  unit.sq_ft = building.sq_ft;
			  }
			  setSelectedUnit(tableData.docs[0]);
			  setDetailsFromUnit(tableData.docs[0], setPropertyDetails);
			  setUserAddedUnit(null);
			  
		  }
		  setUnits(false);
	  }else{
		  setUnits(tableData.docs || []);
	  }
	  
	}
  };

  // Disable the "Generate Report" button if any required field is empty
  const isReportDisabled = propertyDetails.bedrooms === "" ||
						   propertyDetails.baths === "" ;
  
  return (
	  <div className="property-selector-container">
		{savedDraft && (
		  <div style={{
			background: '#FFF3CD', border: '1px solid #FFE69C', borderRadius: 8,
			padding: '16px 20px', marginBottom: 20,
			display: 'flex', justifyContent: 'space-between', alignItems: 'center'
		  }}>
			<div>
			  <strong style={{ fontSize: 18 }}>You have a saved Comp Report</strong>
			  <div style={{ fontSize: 14, color: '#666', marginTop: 4 }}>
				{savedDraft.compSettings && savedDraft.compSettings.selectedBuilding
				  ? savedDraft.compSettings.selectedBuilding.display_full_street_address
				  : 'Previous report'}
				{savedDraft.compSettings && savedDraft.compSettings.selectedUnit
				  ? ' — Unit ' + savedDraft.compSettings.selectedUnit
				  : ''}
				{' · Saved ' + formatTimeAgo(savedDraft.savedAt)}
			  </div>
			</div>
			<div style={{ display: 'flex', gap: 10 }}>
			  <Button
				variant="contained"
				size="small"
				className={classes.searchButton}
				onClick={() => onRestoreDraft(savedDraft)}
			  >
				Load Last Report
			  </Button>
			  <Button
				variant="outlined"
				size="small"
				className={classes.resetButton}
				onClick={() => { deleteCompDraft(); setSavedDraft(null); }}
			  >
				Start Fresh
			  </Button>
			</div>
		  </div>
		)}
  	  	<h2 className="property-selector-heading">Create a Comp Report</h2>
			<div style={{textAlign:"left", fontSize:22, margin:"10px 0"}}>Input your subject property to create a Comparative Market Analysis.  Enter your own price, or let AI suggest one — the final decision rests with your expertise and strategy.</div>
			<hr className="property-selector-spacer" />
			
			<div className="property-selector-section">
			  <div className="property-selector-step">1</div>
			  <div className="property-selector-text">
				<h3>Choose a Subject Property</h3>
				<div className="property-selector-subtext">Enter an address or building name (no unit), then select a unit if applicable. </div>
			  </div>
			</div>
		<div className="property-selector-row">
		  <GeneralBuildingSearchBar
			buildingFilter='(ownership_type:"condo" OR ownership_type:"condo-retail" OR building_status:"sponsor" OR ownership_type:"coop" OR ownership_type:"rental")'
			handleSearch={handleBuildingSelect}
			condoCoopOnly={false}
			buildingAttributes={[]}
			placeHolder={"Address or Building Name"}
			addBuilding={false}
			buildingTab={null}
			hideBoroHood={true}
			hideAddIcon={true}
			hideMapDraw={true}
			searchBarStyles={searchBarBuildingStyles}
			exitMessageData={{
			  title: "Report Unavailable",
			  message:
				"Comp reports are currently available for condos, co-ops and townhouses. Click continue if you would like to learn more about this property on our public website."
			}}
			className="internal-search"
		  />
  
		  {units ? 
			  <Autocomplete
				options={
				  (userAddedUnit &&
				  !(units || []).some(function (item) {
					return (
					  item.address_2_normalized.toUpperCase() === userAddedUnit.toUpperCase() ||
					  item.address_2_normalized.toUpperCase().replace("APT ", "") === userAddedUnit.toUpperCase()
					);
				  })
				  ? ['Add ' + userAddedUnit + '']
				  : []
				).concat(units || []).map(function (item) {
				  if (typeof item === "string") return item;
				  return item.address_2_normalized.toUpperCase().replace("APT", "Apt");
				})}
				getOptionLabel={function (option) {
				  if (option.indexOf("Add") === 0) return option;
				  return option || "";
				}}
				freeSolo
				inputValue={userAddedUnit || ""}
				onInputChange={function (event, newInputValue) {
				  console.log("onInputChange", newInputValue);
				  if(newInputValue && newInputValue.indexOf("Add") === 0){
					setUserAddedUnit(newInputValue.trim().replace("Add ", ""));
				  } else {
					setUserAddedUnit(newInputValue || "");
				  }
				}}
				onKeyDown={function (event) { 
				  if (event.key === "Enter") {
					console.log("onKeyDown", userAddedUnit, selectedUnit);
					if(userAddedUnit !== selectedUnit){
					  handleUnitSelect(userAddedUnit);
					}
				  }
				}}
				onChange={function (event, newValue) {
				  console.log("onChange", newValue);
				  if (newValue && newValue.indexOf("Add") === 0) {
					var newUnit = userAddedUnit.trim().replace("Add ", "");
					setSelectedUnit(newUnit);
					setUserAddedUnit(null);
					setDetailsFromUnit(false, setPropertyDetails);
				  } else if (
					(units || []).some(function (item) {
					  return (
						item.address_2_normalized.toUpperCase() ===
						(newValue ? newValue.toUpperCase() : "")
					  );
					})
				  ) {
					handleUnitSelect(newValue);
				  } else {
					setSelectedUnit("");
					setUserAddedUnit(null);
				  }
				}}
				renderOption={function (option) {
				  if (option.indexOf("Add") === 0) {
					return (
					  <React.Fragment>
						<div style={{ fontWeight: "bold", color: "#333", borderBottom: "1px solid #ddd", paddingBottom:10, paddingTop:10, width:"100%" }}>
						  {option}
						</div>
						<hr style={{ margin: "4px 0", borderTop: "1px solid #ddd" }} />
					  </React.Fragment>
					);
				  }
				  return <div>{option}</div>;
				}}
				renderInput={function (params) {
				  return (
					<TextField
					  {...params}
					  placeholder="Select or Add Unit"
					  variant="outlined"
					  InputProps={{
						...params.InputProps,
						classes: {
						  root: classes.outlinedTextField,
						  input: classes.inputInput,
						},
					  }}
					  style={{marginLeft:20}}
					/>
				  );
				}}
			  />
			: null}
		</div>
  
		{selectedUnit && (
		 <Fragment>
		  <div>
			<hr />
			<div className="property-selector-section">
			  <div className="property-selector-step">2</div>
			  <div className="property-selector-text">
				<h3>{isReportDisabled ? "Add Details for the Subject Property" : "Confirm Subject Property Details"}</h3>
				<div className="property-selector-subtext">
				  {isReportDisabled
					? "Add details about this property. "
					: "Double-check the property information. Edit as necessary."}
				</div>
			  </div>
			</div>
			
  
			<div className="property-selector-flex">
			  <TextField
				required
				error={propertyDetails.bedrooms === ""}
				variant="outlined"
				placeholder="Bedrooms"
				label="Bedrooms"
				value={propertyDetails.bedrooms}
				onChange={(e) => {
				  const value = e.target.value;
				  if (/^\d*\.?\d*$/.test(value)) {
					handleDetailChange("bedrooms", value);
				  }
				}}
				InputProps={{
				  classes: {
					root: classes.outlinedTextField,
					input: classes.inputInput
				  }
				}}
				helperText="(Required)"
			  />
			  <TextField
				required
				error={propertyDetails.baths === ""}
				variant="outlined"
				placeholder="Bathrooms"
				label="Bathrooms"
				value={propertyDetails.baths}
				onChange={(e) => {
				  const value = e.target.value;
				  if (/^\d*\.?\d*$/.test(value)) {
					handleDetailChange("baths", value);
				  }
				}}
				InputProps={{
				  classes: {
					root: classes.outlinedTextField,
					input: classes.inputInput
				  }
				}}
				helperText="(Required)"
			  />
			  <TextField
				// required
				//error={propertyDetails.sq_ft === ""}
				variant="outlined"
				placeholder="Square Foot"
				label="Square Foot"
				value={propertyDetails.sq_ft}
				onChange={(e) => {
				  let raw = e.target.value.replace(/[^0-9.]/g, "");
				  const parts = raw.split(".");
				  if (parts.length > 2) {
					raw = parts[0] + "." + parts.slice(1).join("");
				  }
				  handleDetailChange("sq_ft", raw);
				}}
				InputProps={{
				  classes: {
					root: classes.outlinedTextField,
					input: classes.inputInput
				  }
				}}
				helperText="(Recommended)"
			  />
			  
			</div>
		  </div>
		  <div>
			  <hr />
			  <div className="property-selector-section">
				<div className="property-selector-step">3</div>
				<div className="property-selector-text">
				  <h3>{"Enter Your Price (Optional)"}</h3>
				  <div className="property-selector-subtext">
					Have a price in mind? Enter it here. Leave blank to see the AI’s suggestion.
				  </div>
				</div>
			  </div>
			  
		  
			  <div className="property-selector-flex">
				
				<TextField
					variant="outlined"
					placeholder="Suggested Price"
					label="Suggested Price"
					value={formatCurrencyLive(propertyDetails.customPrice)}
					onChange={(e) => {
					  let raw = e.target.value.replace(/[^0-9.]/g, "");
					  const parts = raw.split(".");
					  if (parts.length > 2) raw = parts[0] + "." + parts.slice(1).join("");
					  handleDetailChange("customPrice", raw);
					}}
					InputProps={{
					  classes: {
						root: classes.outlinedTextField,
						input: classes.inputInputLong,
					  },
					}}
					helperText="(Optional)"
				  />
		  
				{reportItem && reportItem.isMedia && <MediaUpload />}
		  
				<div className="property-selector-button-row">
				  <Tooltip title="Generate Comp Report with Selected Subject Property">
					<span>
					  <Button
						startIcon={<RefreshIcon />}
						className={classes.searchButton}
						onClick={updateBuildingReport}
						disabled={isReportDisabled}
					  >
						Create Report
					  </Button>
					</span>
				  </Tooltip>
				  <Tooltip title="Reset Subject Property">
					<Button className={classes.resetButton} onClick={reset}>
					  Reset
					</Button>
				  </Tooltip>
				</div>
			  </div>
			</div>
		 </Fragment>
		)}
	  </div>
	);
}
